import { useEffect } from "react";
import { API_URL } from "./Constant";
import { iCategorie, iService, iSubCategory } from "./interface";

/* eslint-disable @typescript-eslint/no-non-null-assertion */
export function setPageTitle(title?: string) {
  document.title = title
    ? `${title} - Coifferie EM`
    : "Coifferie EM - Espace de bien-être pour tous";
}

export function setMeta(keywords?: string, description?: string) {
  keywords &&
    document
      .querySelector('meta[name="keywords"]')!
      .setAttribute("content", keywords);
  description &&
    document
      .querySelector('meta[name="description"]')!
      .setAttribute("content", description);
}

export function setJsonLd({ category }: { category?: iCategorie }) {
  const offerings = {
    "@context": "http://schema.org/",
    "@type": "ItemList",
    name: "Coifferie EM",
    itemListElement: category?.attributes.subCategories?.data?.map(
      (subCategory: iSubCategory) => {
        return {
          "@type": "ItemList",
          name: subCategory.attributes.name,
          itemListElement: subCategory.attributes.service?.map(
            (service: iService) => ({
              "@type": "Product",
              name: service.name,
              offers: {
                availability: "in_stock",
                "@type": "Offer",
                priceCurrency: "CAD",
                url: `www.coifferieem.ca/services/${category.attributes.slug}`,
                price: service.price || 0,
              },
            })
          ),
        };
      }
    ),
  };

  let el = document.getElementById("ldschema") as HTMLScriptElement;

  if (!el) {
    el = document.createElement("script");
  }

  if (category) {
    el.type = "application/ld+json";
    el.id = "ldschema";
    el.innerHTML = JSON.stringify(offerings);
    document.head.appendChild(el);
  } else {
    el && el.remove();
  }
}

/** Build a public URL for a Strapi upload from hash + extension. */
export function mediaUrl(hash?: string, ext?: string) {
  if (!hash || !ext) return "";
  return `${API_URL}/uploads/${hash}${ext}`;
}

export const GOOGLE_MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps/dir//Coifferie+EM,+5245+R.+Saint-Denis,+Montr%C3%A9al,+QC+H2J+2M1/@45.5280055,-73.5919443,19z/data=!4m9!4m8!1m0!1m5!1m1!1s0x4cc9197d5a0abf57:0x1b4cce7cc655df6b!2m2!1d-73.5913933!2d45.5280081!3e0";

/** Apply document title / meta / JSON-LD when page data changes. */
export function usePageSeo({
  title,
  keywords,
  description,
  category,
}: {
  title?: string;
  keywords?: string;
  description?: string;
  category?: iCategorie;
}) {
  useEffect(() => {
    setJsonLd({ category });
    setPageTitle(title);
    setMeta(keywords, description);
  }, [title, keywords, description, category]);
}
